<template>
  <div class="knd-scrolly" :class="[customClass]" >
      <div class="knd-scrolly-container" ref="scrolly" :class="[{'is-meta': metaApp}]">
        <div class="knd-scrolly-bg" ref="scrollybg">
            <!-- <img :src="ASSETS + image.url" v-if="image.url"/> -->
            <Vue3Lottie 
              v-if="data.MediaFiles && !metaApp"
              :animationLink="ASSETS + data.MediaFiles[0].url"
              ref="lottieContainer"
              :autoPlay="false"
              :loop="false"
              @onAnimationLoaded="initAnimation"
            />
        </div>

        <div class="knd-steps" ref="steps">
          <ScrollSection 
            v-for="(stap, index) in data.stappen" 
            :call-back="(e) => onEnter(e, index)"
            :index="index"
            :key="index" >

            <Vue3Lottie 
              v-if="data.MediaFiles && metaApp"
              :animationLink="ASSETS + data.MediaFiles[0].url"
              :ref="'lottieContainer-' + index"
              :autoPlay="false"
              :loop="false"
              @onAnimationLoaded="initFrame(index, data.stappen.length)"
            />
            
            <div class="knd-step">
              <div v-html="stap.tekst"></div>
            </div>
          </ScrollSection>

        </div>
        <div class="knd-space"></div>
    </div>
</div>
</template>

<script>
  import ScrollSection from "./ScrollSection.vue";
  import { ref } from "vue";

  import { Vue3Lottie } from 'vue3-lottie'
  import 'vue3-lottie/dist/style.css'

  import gsap from "gsap"
  import ScrollTrigger from 'gsap/ScrollTrigger'
  gsap.registerPlugin(ScrollTrigger)


  export default {
    name: 'Scrolly',
    props: ['data'],
    components: {ScrollSection, Vue3Lottie},
    data() {
      return {
        ASSETS: process.env.VUE_APP_ASSETS,
        image: {},
        currentStep: null,
        customClass: this.data.className || '',
        metaApp: false
      }
    },
    mounted: function() {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

      this.metaApp = this.isMetaApp();
    },
    methods: {
      isMetaApp() {
        var ua = navigator.userAgent || navigator.vendor || window.opera;
        return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1) || (ua.indexOf('Instagram') > -1) ;
      },

      initAnimation() {
        const width  = window.innerWidth || document.documentElement.clientWidth || 
document.body.clientWidth;
        let start = "top top";
        if(width < 680) {
          start = "top center";
        }

        this.LottieScrollTrigger({
          target: this.$refs.steps,
          speed: "slow",
          start: start,
          scrub: 1 // seconds it takes for the playhead to "catch up"
          // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See https://greensock.com/docs/v3/Plugins/ScrollTrigger
          });
      },

      initFrame(index, total) {
        let ref = this.$refs['lottieContainer-' + index][0];
        let totalFrames = ref.getDuration();

        let dividedNum = Math.round(totalFrames/ total);
        let currentFrame = dividedNum * index;

        ref.playSegments([currentFrame, currentFrame + 1], true);
        ref.stop();
      },

    onEnter(el, index) {
      let elSteps = this.$refs.steps.querySelectorAll('.knd-step');
      this.currentStep = 'Stap ' + index;

      elSteps.forEach((el, i) => {
        el.classList.remove('active');
        if(index === i) {
          el.classList.add('active');
          
        }
      })
    },
    LottieScrollTrigger(vars) {
    
    let playhead = {frame: 0},
        target = vars.target,
        speeds = {slow: "+=2000", medium: "+=1000", fast: "+=500"},
        st = {
          trigger: target, 
          pin: false, 
          markers: false, 
          start: "top top", 
          end: `+=${target.offsetHeight - target.children[0].offsetHeight}`,
          // end: speeds[vars.speed] || "+=1000", 
          scrub: 1
        };
       
        let ctx = gsap.context && gsap.context();

        for (let p in vars) { // let users override the ScrollTrigger defaults
            st[p] = vars[p];
        }

        let animation = this.$refs.lottieContainer;
        let totalFrames = animation.getDuration();

        let createTween = function() {
            animation.frameTween = gsap.to(playhead, {
                frame: totalFrames - 1,
                ease: "none",
                onUpdate: () => animation.goToAndStop(playhead.frame, true),
                scrollTrigger: st
            });
            return () => animation.destroy && animation.destroy();
          };
          ctx && ctx.add ? ctx.add(createTween) : createTween();
          // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
          ScrollTrigger.sort();
          ScrollTrigger.refresh(); 
    }


    }
}

</script>

<style lang="scss">

.lottie-animation-container {
  margin: 0;
  --lottie-animation-container-width: auto !important;
	--lottie-animation-container-height: 40vh !important;
  
  margin: 0 auto;

  @include md {
    --lottie-animation-container-width: 50vw !important;
		--lottie-animation-container-height: 80vh !important;
  }
}

.knd-scrolly {
  @include sm {
      position: relative;

      &:before {
        content: " ";
        width: 100%;
        height: 120px;
        position: sticky;
        left: 0;
        top: 0;
        right: 0;
        z-index: 10000;
        display: block;
        background: linear-gradient(to bottom, #4e233e, rgba(255,255,255,0) 90%) repeat scroll;
        /* background: red; */
    }

       &:after {
        content: " ";
        width: 100%;
        height: 120px;
        position: sticky;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 10000;
        display: block;
        background: linear-gradient(to bottom, rgba(255,255,255,0),  #4e233e 90%) repeat scroll;
      }
    }
}

.knd-scrolly-container {
  position: relative;
  max-width: 1440px;
  margin: 0 auto;

  &.is-meta {

    --stepper-margin: 0 auto;

    .knd-scrolly-bg {
      height: auto;
    }

    .scrollStep {
      height: auto;
    }
  }
}

.lottie-animation-container {

	padding-bottom: 30px;
	svg {
		background: #4e233e;
	}
	&:after {
    content: " ";
    width: 100%;
    height: 30px;
    position: relative;
    bottom: 0;
    z-index: 10000;
    display: block;
    background: linear-gradient(to bottom, #4e233e, rgba(255,255,255,0) 90%) repeat scroll;
	}
	@include sm {
		padding-bottom: 0; 
		&:after {
			content: none;
		}
  }
}

.knd-left-pos {
  @include md { 
  .knd-scrolly-bg {
      justify-content: end;
    }
    
    .scrollStep {
      place-items: center start;   
    }

    .card {
      margin: var(--stepper-margin-left);
    }
  }
}

.knd-scrolly-bg {
    position: sticky;
		top: 0rem;
		transition: all 1s;
		

		@include md { 
      height: auto;
			display: flex;
			align-items: center;
      height: 100vh;
		}

    img {
      position: absolute;
      width: 100vw;
      height: auto;

      @include md { 
        width: 50vw;
      }
    }
	}

  .knd-scrolly {
    transition: background .2s ease-in;
    background: var(--stepper-background);
    color: var(--stepper-color);
  }

  .knd-steps {
    
    @include sm {
      position: relative;
    }

    .knd-step {
      background: #F4FFE7;
      border-radius: var(--stepper-border-radius);
      padding: var(--stepper-padding);
    }
  }

  .knd-space {
    height: 0vh;
  }

  .knd-scrolly-bg {
    svg {
      #man, #foon, #foon2, , #pa, #vader {
        filter: blur(20px);
      }

      #merel {
        filter: blur(10px);
      }
    }
  }

</style>